import { Fragment } from 'react';
import './ErrorPage.css';
import { Button } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import Lottie from "lottie-react"

import animation_404 from '../../assets/07_Traverse_404.json';

const ErrorPage = () => {
    const history = useHistory();

    const navigateHome = () => {
        history.push('/');
    }

    return <Fragment>
        <div className="AppContent">
            <div className="ErrorContainer">
                <Lottie style={{height: 240}} loop={false} animationData={animation_404}/>
                <div className="ErrorTitle">Page not found</div>
                <div className="ErrorContent">We searched high and low but couldn't find what you're looking for. Please contact our support if you need help</div>
                <Button
                    onClick={navigateHome}
                    variant="contained"
                    color="primary"
                    className="ErrorButton">
                    Traverse Home
                </Button>
            </div>
        </div>
    </Fragment>
}

export default ErrorPage;